import { render, staticRenderFns } from "./FilterSVG.vue?vue&type=template&id=3ac89e95&scoped=true&"
import script from "./FilterSVG.vue?vue&type=script&lang=js&"
export * from "./FilterSVG.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ac89e95",
  null
  
)

export default component.exports